import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { ContextMenu } from "primereact/contextmenu";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../apiClient";
import colors from '../colors';

function ManageOrders(props)
{
    
    const [orders,setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState({keyword:"",creator:""});
    const cm = useRef(null);
    const toast = useRef(null);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const navigate = useNavigate();
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const [updateOrders,setUpdateOrders] = useState(0);
        

    
    const menuModel = [
      
      ...(selectedOrder?.status === "approve"
          ? [{ label: 'تایید مقاله', icon: 'pi pi-fw pi-check', command: () => approveOrder(selectedOrder._id,selectedOrder.creator?.phone) }]
          : []),
      ...(selectedOrder?.status === "done"
          ? [{ label: 'عدم تایید مقاله', icon: 'pi pi-fw pi-times', command: () => unapproveOrder(selectedOrder._id) }]
          : []),
      { label: 'حذف', icon: 'pi pi-fw pi-trash', command: () => setShowConfirmDelete(true) },
  ];
  

    const approveOrder = async(_id,user_phone) =>
    {
      await apiClient.get(process.env.REACT_APP_BACK+"/orders/approve_order/" + _id, config)
        .then(response =>
        {
          if(response.status==200)
          {
                setUpdateOrders(updateOrders+1);    

                //send sms to owner saying her aticle is ready:
                var d = JSON.stringify({
                            "code": "0zc5os45v8qmdh5",
                            "sender": "+983000505",
                            "recipient": user_phone,
                            "variable": {
                              "verification-code": 1111
                            }
                          });
      
      
                var config1 = {
                  method: 'post',
                  url: 'https://api2.ippanel.com/api/v1/sms/pattern/normal/send',
                  headers: { 
                    'apikey': 'bv1PxCuaPVZUcIPOSqgmx7u9w8nzdBk1Boj_vnwvo48=', 
                    'Content-Type': 'application/json'
                  },
                  data : d
                };
      
                apiClient(config1)
                .then(function (response) {
                  
                  if(response.status === 200)
                  {
                    toast.current.show({
                        severity: "success",
                        detail: "پیامک آماده شدن مقاله به شماره همراه  کاربر ارسال شد",
                      });
                
                    
               
                  }
                  
                })
                .catch(function (error) {
                  console.log("error",error);
                
                });
              
          }

        })
        .catch(error => {
          console.log(error);
        
       });

    }

    const unapproveOrder = async(_id) =>
      {
        await apiClient.get(process.env.REACT_APP_BACK+"/orders/unapprove_order/" + _id, config)
          .then(response =>
          {
            if(response.status==200)
            {
                  setUpdateOrders(updateOrders+1);    
                
            }
  
          })
          .catch(error => {
            console.log(error);
          
         });
  
      }

   

    const writeArticle = async(_id,creator) =>
    {


      
      await apiClient.get(process.env.REACT_APP_BACK+"/sitemap/create_article_for_order/" + _id+"/"+creator._id, config)
        .then(response =>
        {
          if(response.status==200)
          {
              
              if(response.data==="empty")
                toast.current.show({severity: 'error', summary: 'محتوایی برای نوشتن مقاله یافت نشد. لطفا فایل مربوطه را تکمیل نمایید'});
              else
              {
                toast.current.show({severity: 'success', summary: 'مقاله با موفقیت منتشر شد'});
                setUpdateOrders(updateOrders+1);    
              }
          }

        })
        .catch(error => {
          console.log(error);
        
       });
    }

    const showArticleForOrder =  async(order_id) =>
    {
      await apiClient.get(process.env.REACT_APP_BACK+"/articles/article_for_order/" + order_id, config)
      .then(response => 
        {
          if (response.status == 200)
          {
            
            const article = response.data;  
            window.open("/articles/user_"+article.creator+"/" +article._id , "_blank");
            
          }

      })
      .catch(error => {
         console.log(error);
  
      });

    }
  


    const deleteOrderFromDB = async (_id) => 
    {
      await apiClient.delete(process.env.REACT_APP_BACK+"/orders/" + _id, config)
      .then(response => 
        {
          if (response.status == 200)
          {
            
            toast.current.show({severity: 'info', summary: 'سفارش حذف شد'});
            setUpdateOrders(updateOrders+1);    
            
          }

      })
      .catch(error => {
         console.log(error);
     
      });
    };

   

    //get all orders from database:
    useEffect(() => {
    async function getAllOrders() {

      
      const result = await apiClient.get(process.env.REACT_APP_BACK+"/orders/all", config)
      .then((result) => {
        if (result.status == 200) {
          setOrders(result.data);
        }
      })
      .catch((error) => {
        console.log(error);
        
      });
      

    }
    getAllOrders();
  },[updateOrders]);

  
  const regDateBodyTemplate = (rowData) => {
    return new Date(rowData.createdDate).toLocaleDateString('fa-IR');
};

const statusBodyTemplate = (rowData) =>
{
  let status="ثبت شده";
  if(rowData.status==="approve")
    status="نیاز به تایید"
  
  else if(rowData.status==="done")
    status="تایید شده";
  else if(rowData.status==="delivered")
    status="دیده شده";

  return <span style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
    {status}
    { (rowData.status==="done" || rowData.status==="delivered") &&
    <i className="pi pi-check"
      style={{color:"#219D34 ",border:'1px #219D34 solid',marginRight:'10px',fontSize:'20px',background: "rgba(157, 218, 158, 0.48)", padding: "10px", borderRadius: "50%"}}>
      </i>
    }
  </span>;

}

const creatorBodyTemplate = (rowData) =>
{
  const creator = rowData.creator?.phone;

  return creator;
}

const showIconBodyTemplate = (rowData) =>
    {

      if(rowData.status==="registered")
        return <div >
        <button  
          className="manager-button"
          style={{fontSize:'12px'}}
          onClick={()=>writeArticle(rowData._id,rowData.creator)}
      >
        ساخت مقاله</button>
        
        </div>
        else
        return <div >
        <button  
          className="manager-button"
          style={{fontSize:'12px'}}
          onClick={() => showArticleForOrder(rowData._id)}
          
      >
        نمایش مقاله</button>
        
        </div>




        
    }

 

    

    return(

        <div id="manage-pages">

            <h2>
            مدیریت سفارش ها
            </h2>

            <span style={{display:'flex' , paddingRight: desktop ? '50px' : '15px', paddingBottom:'50px'}}>
             

            </span>

            <Toast ref={toast} position="center"></Toast>

            <ContextMenu model={menuModel} ref={cm} />

            <DataTable size="normal" value={orders} paginator rows={20} editMode="row"
            className="mobile-datatable"
            contextMenuSelection={selectedOrder}
            onContextMenuSelectionChange={e => setSelectedOrder(e.value)}
            onContextMenu={e => cm.current.show(e.originalEvent)}
            // style={{ width: desktop ? '95%' : null}}
            // resizableColumns={false}
            >
          
            
            
            <Column alignHeader="center" columnKey="keyword" align="center" field="keyword" header="کلمه کلیدی"  filter ></Column>
            <Column alignHeader="center" columnKey="createdDate" align="center" field="createdDate" header="تاریخ ایجاد" body={regDateBodyTemplate} sortable></Column>
            <Column alignHeader="center" columnKey="creator" align="center" field="createdDate" header="کاربر" body={creatorBodyTemplate}  filter></Column>
            <Column alignHeader="center" columnKey="status" align="center" field="createdDate" header="وضعیت" body={statusBodyTemplate} sortable filter></Column>
            <Column alignHeader="center" columnKey="show" align="center" field="show" header="" body={showIconBodyTemplate} ></Column>
            
            
            </DataTable>


            <ConfirmDialog 
            className={props.theme}
            visible={showConfirmDelete} 
            onHide={() => setShowConfirmDelete(false)} 
            message="آیا از حذف این سفارش مطمئنید؟"
            header="تایید حذف"
            icon="pi pi-info-circle"
            acceptLabel="بله"
            rejectLabel="نه"
            acceptClassName="accept"
            rejectClassName="reject"
            accept={() => deleteOrderFromDB(selectedOrder._id)} 
            reject={() => setShowConfirmDelete(false)} />

          

        </div>
    );

}

export default ManageOrders;